import { useState } from 'react';
import { getWidgetVersionChangeActions, WidgetVersionChangeMask } from './widgetVersionHelper';

// This is used to force a page reload of the widget when the version changes from the backend
export const useWidgetVersion = (newVersion: number | undefined) => {
  const [currentVersion, setVersion] = useState<number | undefined>(undefined);
  const action = getWidgetVersionChangeActions(currentVersion, newVersion);

  if (action & WidgetVersionChangeMask.Store) {
    setVersion(newVersion);
  }

  if (action & WidgetVersionChangeMask.ReloadPage) {
    window.location.reload();
  }
};
